import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import pt from "vuetify/es5/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    dark: false,
    themes: {
      light: {
        primary: "#285495",
        secondary: "#3f3d3c",
        accent: "#5E948E",
        error: "#FF4500",
        info: "#2196F3",
        success: "#7BCF7D",
        warning: "#FFB40F",
        red: "FF4040"
      },
      dark: {
        primary: "#41B883",
        secondary: "#f1f1f1",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#7BCF7D",
        warning: "#FFC107"
      }
    }
  },
  lang: {
    locales: { pt },
    current: "pt"
  }
});
